import Skeleton from "../Skeleton";
import "./_form-page-skeleton.scss";

const SECTION_FIELD_COUNTS = [4, 2];

/**
 * Generic placeholder for a wizard/form page's body while its initial data
 * (an edit/duplicate fetch, or a hard-refresh refetch) is still loading.
 * Pairs with a real PageHeaderBar/WizardSteps in the page host - those are
 * already known synchronously (static title/steps), so only the body
 * (whose shape depends on the fetched record) needs a placeholder. See
 * UpsellEditPage, ProposalEditPage, SubscriptionEditPage, ProductManagePage,
 * PlanManagePage.
 */
const FormPageSkeleton = () => (
  <div className="form-page-skeleton">
    {SECTION_FIELD_COUNTS.map((fieldCount, sectionIndex) => (
      <div className="form-page-skeleton__section" key={sectionIndex}>
        <Skeleton width="140px" height="14px" />
        <div className="form-page-skeleton__fields">
          {Array.from({ length: fieldCount }).map((_, fieldIndex) => (
            <div className="form-page-skeleton__field" key={fieldIndex}>
              <Skeleton width="90px" height="11px" />
              <Skeleton width="100%" height="38px" radius="6px" />
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default FormPageSkeleton;
